import { jwtDecode } from 'jwt-decode';
import store from '../store';
import { clearUser as clearUserSlice } from '../redux/slices/userSlice';
import { clearUser } from '../redux/actions/authActions';
import { authApi } from '../api/authApi';

// Helper: check if token expired
export const isTokenExpired = (token) => {
  try {
    const { exp } = jwtDecode(token);
    return Date.now() >= exp * 1000;
  } catch (err) {
    return true;
  }
};

// Helper: clear all auth state
export const clearAuthState = () => {
  sessionStorage.removeItem('authToken');
  sessionStorage.removeItem('refreshToken');
  sessionStorage.removeItem('user');
  store.dispatch(clearUser());
  store.dispatch(clearUserSlice());
};

// Helper: validate current token and clear if expired
export const validateAndClearExpiredToken = () => {
  const token = sessionStorage.getItem('authToken');
  if (token && isTokenExpired(token)) {
    clearAuthState();
    return false;
  }
  return !!token;
};

// Helper: refresh access token using refresh token
export const refreshAccessToken = async () => {
  try {
    const refreshToken = sessionStorage.getItem('refreshToken');
    if (!refreshToken) {
      throw new Error('No refresh token available');
    }

    const response = await authApi.refreshToken(refreshToken);
    
    if (response.status === 200 && response.accessToken) {
      sessionStorage.setItem('authToken', response.accessToken);
      return response.accessToken;
    }
    
    throw new Error('Failed to refresh token');
  } catch (error) {
    clearAuthState();
    throw error;
  }
};

// Helper: check if refresh token is valid
export const isRefreshTokenValid = () => {
  const refreshToken = sessionStorage.getItem('refreshToken');
  return refreshToken && !isTokenExpired(refreshToken);
};